<template>
   <div>
        <loader :is-visible="isLoading"></loader>
        <div class="container">
            <div class="container-post">
                <div class="form-modal">
                    <div class="section-list">
                        <button  class="close btn--cat" @click="back()"></button>
                        <ul class="main-post">
                            <li class="list-post list--post btm-margin">
                                <p>Category</p>
                                <p>Category Id</p>
                                <p>Date</p>
                            </li>
                            <div class="list-post__item">
                                <li class="list-post list--post" v-for="(data,index) in listCategory" :key="index">
                                    <div class="list-post__title">
                                        <p>{{ data.name}}</p>
                                        <button class="button" @click="catForm(data)">Edit</button>
                                        <button class="button" @click="delData(data.cat_id)">Delete</button>
                                    </div>
                                    <div>
                                        <p class="main-post__author">{{ data.cat_id}}</p>
                                    </div>
                                    <p class="main-post__date">{{ formatDate(data.dtm_upd.Time) }}</p>
                                </li>
                            </div>
                        </ul>
                        <paginate
                            :page-range="3"
                            :page-count="totalPages"
                            :margin-pages="2"
                            :click-handler="getListCatNews"
                            :prev-text="'Prev'"
                            :next-text="'Next'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import moment from 'moment';
import axios from 'axios';

export default {
    name: "ViewCategory",
    data() {
        return {
            type: '',
            isLoading: false,
            listCategory: [],
            pageNum: 1,
            totalPages: 0,
            limit: 10,
        }
    },
    methods: {
        formatDate (val) {
            return moment(val).format('DD-MM-YYYY hh:mm:ss')
        },
        async getListCatNews(page) {
            this.pageNum = page
            this.isLoading = true
            try {
                const response = await axios.get('/content/listnewscategory', {
                    params: {
                        page: this.pageNum,
                        limit: this.limit
                    }
                })
                console.log(response)

                this.listCategory = response.data.data

                this.totalPages = Math.ceil(response.data.meta.total_data / this.limit)
                console.log('dataCat', this.listCategory)
                this.isLoading = false
            } catch (error) {
                console.log(error)
            }
        },
        async catForm(data) {
            console.log('dataCatEdit', data)
            const dataById = JSON.stringify(data)
            localStorage.setItem('dataCatBerita', dataById)
            if ( this.type === 'berita') {
                this.$router.push(`/form-category/berita/${data.cat_id}`)
            }
        },
        async delData(id) {
            console.log('idCat', id)
            let self = this
            alert.confirmation( async function () {
                self.isLoading = true
                try {
                    const response = await axios.delete(`/content/newscategory/${id}`)
                    self.isLoading = false
                    console.log(response)
                    alert.success('Delete data success', () => self.getListCatNews(1))
                } catch (error) {
                    self.isLoading = false
                    console.log(error)
                    alert.failed('Delete data failed')
                }
            }, 'Are you sure to delete it?')
        },
        back() {
            this.$router.go(-1)
        }
    },
    components: {
        Loader
    },
    created() {
        this.type = this.$route.params.type
        if (this.type === 'berita') {
            this.getListCatNews(1)
        }
    }
}
</script>